module.exports = __webpack_public_path__ + "img/audit_ru.b559fd31.png";